import {
	LegalPersonTags,
	PersonSummary,
	ValuationSummaryGroupByPersonRes,
} from '@dealstack/shared/lib/generated';

export interface PersonOption {
	personId: string;
	mipId?: string;
	label: string;
	tags: LegalPersonTags[];
}

export interface DefaultPersonSelection {
	personId: string;
	mipId?: string;
}

export function getDefaultPersonSelection(
	persons: PersonSummary[] | undefined
): DefaultPersonSelection | null {
	const firstPerson = persons?.[0];
	if (!firstPerson?.id) {
		return null;
	}
	return {
		personId: firstPerson.id,
		mipId: firstPerson.groups[0]?.id ?? undefined,
	};
}

export function findSelectedPerson(
	persons: PersonSummary[] | undefined,
	selectedPersonId: string | undefined
): PersonSummary | undefined {
	if (!persons || !selectedPersonId) {
		return undefined;
	}
	return persons.find((p) => p.id === selectedPersonId);
}

export function buildPersonOptions(
	data: ValuationSummaryGroupByPersonRes | undefined
): PersonOption[] {
	if (!data?.persons) {
		return [];
	}
	return data.persons.flatMap((person) =>
		person.groups.map((group) => ({
			personId: person.id,
			mipId: group.id ?? undefined,
			label: group.name ? `${person.displayName} (${group.name})` : person.displayName,
			tags: person.classifiers,
		}))
	);
}

export function extractAvailableTags(
	data: ValuationSummaryGroupByPersonRes | undefined
): LegalPersonTags[] {
	return Array.from(new Set(data?.persons.flatMap((person) => person.classifiers) ?? []));
}

export function formatSelectedEntityName(
	entity: PersonSummary | undefined,
	selectedMipId: string | undefined,
	isSummaryFirstLoad: boolean
): string {
	const personName = entity?.displayName ?? (isSummaryFirstLoad ? 'Loading...' : 'Unknown');
	const groupName = entity?.groups.find((group) => group.id === selectedMipId)?.name;
	return groupName ? `${personName} (${groupName})` : personName;
}
